import './kitStyles';
import React from 'react';

/**
 * WEB-3310 юнит 1 — статус кита, эталон `Status({ kind, children })`: точка
 * вида и текст, без цветной подложки. `idle` — пустое кольцо.
 */
export type StatusKind = 'live' | 'idle' | 'off' | 'bad';

export interface StatusProps {
  kind: StatusKind;
  children?: React.ReactNode;
}

export function Status({ kind, children }: StatusProps): React.ReactElement {
  return (
    <span className="status">
      <span className={'dot ' + kind} aria-hidden="true" />
      {children}
    </span>
  );
}
